module.exports = __webpack_public_path__ + "static/media/hand.7bae9d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hand.png
// module id = 41
// module chunks = 0